import mock from "./mock";
import "./navbar/navbarSearch";
import "./navbar/navbarBookmarkSearch";
import "./auth/authentication";
import "./apps/dataView";
import "./apps/userList";
import "./Forms/productForm";

mock.onAny().passThrough();
